import _toConsumableArray from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import * as utils from "./util/utils";
import { MapperType } from "./serializer";
import { DefaultDeserializationOptions, deserializationPolicy } from "./policies/deserializationPolicy";
import { DefaultKeepAliveOptions, keepAlivePolicy } from "./policies/keepAlivePolicy";
import { DefaultRedirectOptions, redirectPolicy } from "./policies/redirectPolicy";
import { DefaultRetryOptions, exponentialRetryPolicy } from "./policies/exponentialRetryPolicy";
import { logPolicy } from "./policies/logPolicy";
import { getPathStringFromParameter, getPathStringFromParameterPath } from "./operationParameter";
import { getStreamResponseStatusCodes } from "./operationSpec";
import { WebResource, isWebResourceLike } from "./webResource";
import { RequestPolicyOptions } from "./policies/requestPolicy";
import { XML_ATTRKEY, XML_CHARKEY } from "./util/serializer.common";
import { isNode } from "./util/utils";
import { isTokenCredential } from "@azure/core-auth";
import { getDefaultUserAgentHeaderName, getDefaultUserAgentValue, userAgentPolicy } from "./policies/userAgentPolicy";
import { QueryCollectionFormat } from "./queryCollectionFormat";
import { URLBuilder } from "./url";
import { bearerTokenAuthenticationPolicy } from "./policies/bearerTokenAuthenticationPolicy";
import { disableResponseDecompressionPolicy } from "./policies/disableResponseDecompressionPolicy";
import { generateClientRequestIdPolicy } from "./policies/generateClientRequestIdPolicy";
import { getCachedDefaultHttpClient } from "./httpClientCache";
import { logger } from "./log";
import { ndJsonPolicy } from "./policies/ndJsonPolicy";
import { proxyPolicy } from "./policies/proxyPolicy";
import { rpRegistrationPolicy } from "./policies/rpRegistrationPolicy";
import { signingPolicy } from "./policies/signingPolicy";
import { stringifyXML } from "./util/xml";
import { systemErrorRetryPolicy } from "./policies/systemErrorRetryPolicy";
import { throttlingRetryPolicy } from "./policies/throttlingRetryPolicy";
import { tracingPolicy } from "./policies/tracingPolicy";
/**
 * ServiceClient sends service requests and receives responses.
 */

export var ServiceClient = /*#__PURE__*/function () {
  /**
   * The ServiceClient constructor
   * @param credentials - The credentials used for authentication with the service.
   * @param options - The service client options that govern the behavior of the client.
   */
  function ServiceClient(credentials,
  /* eslint-disable-next-line @azure/azure-sdk/ts-naming-options */
  options) {
    var _this = this;

    _classCallCheck(this, ServiceClient);

    if (!options) {
      options = {};
    }

    this._withCredentials = options.withCredentials || false;
    this._httpClient = options.httpClient || getCachedDefaultHttpClient();
    this._requestPolicyOptions = new RequestPolicyOptions(options.httpPipelineLogger);
    var requestPolicyFactories;

    if (Array.isArray(options.requestPolicyFactories)) {
      logger.info("ServiceClient: using custom request policies");
      requestPolicyFactories = options.requestPolicyFactories;
    } else {
      var authPolicyFactory = undefined;

      if (isTokenCredential(credentials)) {
        logger.info("ServiceClient: creating bearer token authentication policy from provided credentials"); // Create a wrapped RequestPolicyFactory here so that we can provide the
        // correct scope to the BearerTokenAuthenticationPolicy at the first time
        // one is requested.  This is needed because generated ServiceClient
        // implementations do not set baseUri until after ServiceClient's constructor
        // is finished, leaving baseUri empty at the time when it is needed to
        // build the correct scope name.

        var wrappedPolicyFactory = function wrappedPolicyFactory() {
          var bearerTokenPolicyFactory = undefined; // eslint-disable-next-line @typescript-eslint/no-this-alias

          var serviceClient = _this;
          var serviceClientOptions = options;
          return {
            create: function create(nextPolicy, createOptions) {
              var credentialScopes = getCredentialScopes(serviceClientOptions, serviceClient.baseUri);

              if (!credentialScopes) {
                throw new Error("When using credential, the ServiceClient must contain a baseUri or a credentialScopes in ServiceClientOptions. Unable to create a bearerTokenAuthenticationPolicy");
              }

              if (bearerTokenPolicyFactory === undefined || bearerTokenPolicyFactory === null) {
                bearerTokenPolicyFactory = bearerTokenAuthenticationPolicy(credentials, credentialScopes);
              }

              return bearerTokenPolicyFactory.create(nextPolicy, createOptions);
            }
          };
        };

        authPolicyFactory = wrappedPolicyFactory();
      } else if (credentials && typeof credentials.signRequest === "function") {
        logger.info("ServiceClient: creating signing policy from provided credentials");
        authPolicyFactory = signingPolicy(credentials);
      } else if (credentials !== undefined && credentials !== null) {
        throw new Error("The credentials argument must implement the TokenCredential interface");
      }

      logger.info("ServiceClient: using default request policies");
      requestPolicyFactories = createDefaultRequestPolicyFactories(authPolicyFactory, options);

      if (options.requestPolicyFactories) {
        // options.requestPolicyFactories can also be a function that manipulates
        // the default requestPolicyFactories array
        var newRequestPolicyFactories = options.requestPolicyFactories(requestPolicyFactories);

        if (newRequestPolicyFactories) {
          requestPolicyFactories = newRequestPolicyFactories;
        }
      }
    }

    this._requestPolicyFactories = requestPolicyFactories;
  }
  /**
   * Send the provided httpRequest.
   */


  _createClass(ServiceClient, [{
    key: "sendRequest",
    value: function sendRequest(options) {
      if (options === null || options === undefined || typeof options !== "object") {
        throw new Error("options cannot be null or undefined and it must be of type object.");
      }

      var httpRequest;

      try {
        if (isWebResourceLike(options)) {
          options.validateRequestProperties();
          httpRequest = options;
        } else {
          httpRequest = new WebResource();
          httpRequest = httpRequest.prepare(options);
        }
      } catch (error) {
        return Promise.reject(error);
      }

      var httpPipeline = this._httpClient;

      if (this._requestPolicyFactories && this._requestPolicyFactories.length > 0) {
        for (var i = this._requestPolicyFactories.length - 1; i >= 0; --i) {
          httpPipeline = this._requestPolicyFactories[i].create(httpPipeline, this._requestPolicyOptions);
        }
      }

      return httpPipeline.sendRequest(httpRequest);
    }
    /**
     * Send an HTTP request that is populated using the provided OperationSpec.
     * @param operationArguments - The arguments that the HTTP request's templated values will be populated from.
     * @param operationSpec - The OperationSpec to use to populate the httpRequest.
     * @param callback - The callback to call when the response is received.
     */

  }, {
    key: "sendOperationRequest",
    value: function () {
      var _sendOperationRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(operationArguments, operationSpec, callback) {
        var _a, serializerOptions, httpRequest, result, baseUri, requestUrl, _iterator, _step, urlParameter, urlParameterValue, _iterator2, _step2, queryParameter, queryParameterValue, index, item, _index, contentType, _iterator3, _step3, headerParameter, headerValue, headerCollectionPrefix, _i, _Object$keys, key, options, customHeaderName, rawResponse, sendRequestError, cb;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (typeof operationArguments.options === "function") {
                  callback = operationArguments.options;
                  operationArguments.options = undefined;
                }

                serializerOptions = (_a = operationArguments.options) === null || _a === void 0 ? void 0 : _a.serializerOptions;
                httpRequest = new WebResource();
                _context.prev = 3;
                baseUri = operationSpec.baseUrl || this.baseUri;

                if (baseUri) {
                  _context.next = 7;
                  break;
                }

                throw new Error("If operationSpec.baseUrl is not specified, then the ServiceClient must have a baseUri string property that contains the base URL to use.");

              case 7:
                httpRequest.method = operationSpec.httpMethod;
                httpRequest.operationSpec = operationSpec;
                requestUrl = URLBuilder.parse(baseUri);

                if (operationSpec.path) {
                  requestUrl.appendPath(operationSpec.path);
                }

                if (operationSpec.urlParameters && operationSpec.urlParameters.length > 0) {
                  _iterator = _createForOfIteratorHelper(operationSpec.urlParameters);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      urlParameter = _step.value;
                      urlParameterValue = getOperationArgumentValueFromParameter(this, operationArguments, urlParameter, operationSpec.serializer);
                      urlParameterValue = operationSpec.serializer.serialize(urlParameter.mapper, urlParameterValue, getPathStringFromParameter(urlParameter), serializerOptions);

                      if (!urlParameter.skipEncoding) {
                        urlParameterValue = encodeURIComponent(urlParameterValue);
                      }

                      requestUrl.replaceAll("{".concat(urlParameter.mapper.serializedName || getPathStringFromParameter(urlParameter), "}"), urlParameterValue);
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }

                if (!(operationSpec.queryParameters && operationSpec.queryParameters.length > 0)) {
                  _context.next = 44;
                  break;
                }

                _iterator2 = _createForOfIteratorHelper(operationSpec.queryParameters);
                _context.prev = 14;

                _iterator2.s();

              case 16:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 36;
                  break;
                }

                queryParameter = _step2.value;
                queryParameterValue = getOperationArgumentValueFromParameter(this, operationArguments, queryParameter, operationSpec.serializer);

                if (!(queryParameterValue !== undefined && queryParameterValue !== null)) {
                  _context.next = 34;
                  break;
                }

                queryParameterValue = operationSpec.serializer.serialize(queryParameter.mapper, queryParameterValue, getPathStringFromParameter(queryParameter), serializerOptions);

                if (!(queryParameter.collectionFormat !== undefined && queryParameter.collectionFormat !== null)) {
                  _context.next = 31;
                  break;
                }

                if (!(queryParameter.collectionFormat === QueryCollectionFormat.Multi)) {
                  _context.next = 30;
                  break;
                }

                if (!(queryParameterValue.length === 0)) {
                  _context.next = 27;
                  break;
                }

                return _context.abrupt("continue", 34);

              case 27:
                for (index in queryParameterValue) {
                  item = queryParameterValue[index];
                  queryParameterValue[index] = item === undefined || item === null ? "" : item.toString();
                }

              case 28:
                _context.next = 31;
                break;

              case 30:
                if (queryParameter.collectionFormat === QueryCollectionFormat.Ssv || queryParameter.collectionFormat === QueryCollectionFormat.Tsv) {
                  queryParameterValue = queryParameterValue.join(queryParameter.collectionFormat);
                }

              case 31:
                if (!queryParameter.skipEncoding) {
                  if (Array.isArray(queryParameterValue)) {
                    for (_index in queryParameterValue) {
                      if (queryParameterValue[_index] !== undefined && queryParameterValue[_index] !== null) {
                        queryParameterValue[_index] = encodeURIComponent(queryParameterValue[_index]);
                      }
                    }
                  } else {
                    queryParameterValue = encodeURIComponent(queryParameterValue);
                  }
                }

                if (queryParameter.collectionFormat !== undefined && queryParameter.collectionFormat !== null && queryParameter.collectionFormat !== QueryCollectionFormat.Multi && queryParameter.collectionFormat !== QueryCollectionFormat.Ssv && queryParameter.collectionFormat !== QueryCollectionFormat.Tsv) {
                  queryParameterValue = queryParameterValue.join(queryParameter.collectionFormat);
                }

                requestUrl.setQueryParameter(queryParameter.mapper.serializedName || getPathStringFromParameter(queryParameter), queryParameterValue);

              case 34:
                _context.next = 16;
                break;

              case 36:
                _context.next = 41;
                break;

              case 38:
                _context.prev = 38;
                _context.t0 = _context["catch"](14);

                _iterator2.e(_context.t0);

              case 41:
                _context.prev = 41;

                _iterator2.f();

                return _context.finish(41);

              case 44:
                httpRequest.url = requestUrl.toString();
                contentType = operationSpec.contentType || this.requestContentType;

                if (contentType && operationSpec.requestBody) {
                  httpRequest.headers.set("Content-Type", contentType);
                }

                if (operationSpec.headerParameters) {
                  _iterator3 = _createForOfIteratorHelper(operationSpec.headerParameters);

                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      headerParameter = _step3.value;
                      headerValue = getOperationArgumentValueFromParameter(this, operationArguments, headerParameter, operationSpec.serializer);

                      if (headerValue !== undefined && headerValue !== null) {
                        headerValue = operationSpec.serializer.serialize(headerParameter.mapper, headerValue, getPathStringFromParameter(headerParameter), serializerOptions);
                        headerCollectionPrefix = headerParameter.mapper.headerCollectionPrefix;

                        if (headerCollectionPrefix) {
                          for (_i = 0, _Object$keys = Object.keys(headerValue); _i < _Object$keys.length; _i++) {
                            key = _Object$keys[_i];
                            httpRequest.headers.set(headerCollectionPrefix + key, headerValue[key]);
                          }
                        } else {
                          httpRequest.headers.set(headerParameter.mapper.serializedName || getPathStringFromParameter(headerParameter), headerValue);
                        }
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }

                options = operationArguments.options;

                if (options) {
                  if (options.customHeaders) {
                    for (customHeaderName in options.customHeaders) {
                      httpRequest.headers.set(customHeaderName, options.customHeaders[customHeaderName]);
                    }
                  }

                  if (options.abortSignal) {
                    httpRequest.abortSignal = options.abortSignal;
                  }

                  if (options.timeout) {
                    httpRequest.timeout = options.timeout;
                  }

                  if (options.onUploadProgress) {
                    httpRequest.onUploadProgress = options.onUploadProgress;
                  }

                  if (options.onDownloadProgress) {
                    httpRequest.onDownloadProgress = options.onDownloadProgress;
                  }

                  if (options.spanOptions) {
                    // By passing spanOptions if they exist at runtime, we're backwards compatible with @azure/core-tracing@preview.13 and earlier.
                    httpRequest.spanOptions = options.spanOptions;
                  }

                  if (options.tracingContext) {
                    httpRequest.tracingContext = options.tracingContext;
                  }

                  if (options.shouldDeserialize !== undefined && options.shouldDeserialize !== null) {
                    httpRequest.shouldDeserialize = options.shouldDeserialize;
                  }
                }

                httpRequest.withCredentials = this._withCredentials;
                serializeRequestBody(this, httpRequest, operationArguments, operationSpec);

                if (httpRequest.streamResponseStatusCodes === undefined) {
                  httpRequest.streamResponseStatusCodes = getStreamResponseStatusCodes(operationSpec);
                }

                _context.prev = 53;
                _context.next = 56;
                return this.sendRequest(httpRequest);

              case 56:
                rawResponse = _context.sent;
                _context.next = 62;
                break;

              case 59:
                _context.prev = 59;
                _context.t1 = _context["catch"](53);
                sendRequestError = _context.t1;

              case 62:
                if (sendRequestError) {
                  if (sendRequestError.response) {
                    sendRequestError.details = flattenResponse(sendRequestError.response, operationSpec.responses[sendRequestError.statusCode] || operationSpec.responses["default"]);
                  }

                  result = Promise.reject(sendRequestError);
                } else {
                  result = Promise.resolve(flattenResponse(rawResponse, operationSpec.responses[rawResponse.status]));
                }

                _context.next = 68;
                break;

              case 65:
                _context.prev = 65;
                _context.t2 = _context["catch"](3);
                result = Promise.reject(_context.t2);

              case 68:
                cb = callback;

                if (cb) {
                  result.then(function (res) {
                    return cb(null, res._response.parsedBody, res._response.request, res._response);
                  }).catch(function (err) {
                    return cb(err);
                  });
                }

                return _context.abrupt("return", result);

              case 71:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 65], [14, 38, 41, 44], [53, 59]]);
      }));

      function sendOperationRequest(_x, _x2, _x3) {
        return _sendOperationRequest.apply(this, arguments);
      }

      return sendOperationRequest;
    }()
  }]);

  return ServiceClient;
}();
export function serializeRequestBody(serviceClient, httpRequest, operationArguments, operationSpec) {
  var _a, _b, _c, _d, _e, _f;

  var serializerOptions = (_b = (_a = operationArguments.options) === null || _a === void 0 ? void 0 : _a.serializerOptions) !== null && _b !== void 0 ? _b : {};
  var updatedOptions = {
    rootName: (_c = serializerOptions.rootName) !== null && _c !== void 0 ? _c : "",
    includeRoot: (_d = serializerOptions.includeRoot) !== null && _d !== void 0 ? _d : false,
    xmlCharKey: (_e = serializerOptions.xmlCharKey) !== null && _e !== void 0 ? _e : XML_CHARKEY
  };
  var xmlCharKey = serializerOptions.xmlCharKey;

  if (operationSpec.requestBody && operationSpec.requestBody.mapper) {
    httpRequest.body = getOperationArgumentValueFromParameter(serviceClient, operationArguments, operationSpec.requestBody, operationSpec.serializer);
    var bodyMapper = operationSpec.requestBody.mapper;
    var required = bodyMapper.required,
        xmlName = bodyMapper.xmlName,
        xmlElementName = bodyMapper.xmlElementName,
        serializedName = bodyMapper.serializedName,
        xmlNamespace = bodyMapper.xmlNamespace,
        xmlNamespacePrefix = bodyMapper.xmlNamespacePrefix;
    var typeName = bodyMapper.type.name;

    try {
      if (httpRequest.body !== undefined && httpRequest.body !== null || required) {
        var requestBodyParameterPathString = getPathStringFromParameter(operationSpec.requestBody);
        httpRequest.body = operationSpec.serializer.serialize(bodyMapper, httpRequest.body, requestBodyParameterPathString, updatedOptions);
        var isStream = typeName === MapperType.Stream;

        if (operationSpec.isXML) {
          var xmlnsKey = xmlNamespacePrefix ? "xmlns:".concat(xmlNamespacePrefix) : "xmlns";
          var value = getXmlValueWithNamespace(xmlNamespace, xmlnsKey, typeName, httpRequest.body, updatedOptions);

          if (typeName === MapperType.Sequence) {
            httpRequest.body = stringifyXML(utils.prepareXMLRootList(value, xmlElementName || xmlName || serializedName, xmlnsKey, xmlNamespace), {
              rootName: xmlName || serializedName,
              xmlCharKey: xmlCharKey
            });
          } else if (!isStream) {
            httpRequest.body = stringifyXML(value, {
              rootName: xmlName || serializedName,
              xmlCharKey: xmlCharKey
            });
          }
        } else if (typeName === MapperType.String && (((_f = operationSpec.contentType) === null || _f === void 0 ? void 0 : _f.match("text/plain")) || operationSpec.mediaType === "text")) {
          // the String serializer has validated that request body is a string
          // so just send the string.
          return;
        } else if (!isStream) {
          httpRequest.body = JSON.stringify(httpRequest.body);
        }
      }
    } catch (error) {
      throw new Error("Error \"".concat(error.message, "\" occurred in serializing the payload - ").concat(JSON.stringify(serializedName, undefined, "  "), "."));
    }
  } else if (operationSpec.formDataParameters && operationSpec.formDataParameters.length > 0) {
    httpRequest.formData = {};

    var _iterator4 = _createForOfIteratorHelper(operationSpec.formDataParameters),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var formDataParameter = _step4.value;
        var formDataParameterValue = getOperationArgumentValueFromParameter(serviceClient, operationArguments, formDataParameter, operationSpec.serializer);

        if (formDataParameterValue !== undefined && formDataParameterValue !== null) {
          var formDataParameterPropertyName = formDataParameter.mapper.serializedName || getPathStringFromParameter(formDataParameter);
          httpRequest.formData[formDataParameterPropertyName] = operationSpec.serializer.serialize(formDataParameter.mapper, formDataParameterValue, getPathStringFromParameter(formDataParameter), updatedOptions);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
}
/**
 * Adds an xml namespace to the xml serialized object if needed, otherwise it just returns the value itself
 */

function getXmlValueWithNamespace(xmlNamespace, xmlnsKey, typeName, serializedValue, options) {
  // Composite and Sequence schemas already got their root namespace set during serialization
  // We just need to add xmlns to the other schema types
  if (xmlNamespace && !["Composite", "Sequence", "Dictionary"].includes(typeName)) {
    var result = {};
    result[options.xmlCharKey] = serializedValue;
    result[XML_ATTRKEY] = _defineProperty({}, xmlnsKey, xmlNamespace);
    return result;
  }

  return serializedValue;
}

function getValueOrFunctionResult(value, defaultValueCreator) {
  var result;

  if (typeof value === "string") {
    result = value;
  } else {
    result = defaultValueCreator();

    if (typeof value === "function") {
      result = value(result);
    }
  }

  return result;
}

function createDefaultRequestPolicyFactories(authPolicyFactory, options) {
  var factories = [];

  if (options.generateClientRequestIdHeader) {
    factories.push(generateClientRequestIdPolicy(options.clientRequestIdHeaderName));
  }

  if (authPolicyFactory) {
    factories.push(authPolicyFactory);
  }

  var userAgentHeaderName = getValueOrFunctionResult(options.userAgentHeaderName, getDefaultUserAgentHeaderName);
  var userAgentHeaderValue = getValueOrFunctionResult(options.userAgent, getDefaultUserAgentValue);

  if (userAgentHeaderName && userAgentHeaderValue) {
    factories.push(userAgentPolicy({
      key: userAgentHeaderName,
      value: userAgentHeaderValue
    }));
  }

  factories.push(redirectPolicy());
  factories.push(rpRegistrationPolicy(options.rpRegistrationRetryTimeout));

  if (!options.noRetryPolicy) {
    factories.push(exponentialRetryPolicy());
    factories.push(systemErrorRetryPolicy());
    factories.push(throttlingRetryPolicy());
  }

  factories.push(deserializationPolicy(options.deserializationContentTypes));

  if (isNode) {
    factories.push(proxyPolicy(options.proxySettings));
  }

  factories.push(logPolicy({
    logger: logger.info
  }));
  return factories;
}
/**
 * Creates an HTTP pipeline based on the given options.
 * @param pipelineOptions - Defines options that are used to configure policies in the HTTP pipeline for an SDK client.
 * @param authPolicyFactory - An optional authentication policy factory to use for signing requests.
 * @returns A set of options that can be passed to create a new {@link ServiceClient}.
 */


export function createPipelineFromOptions(pipelineOptions, authPolicyFactory) {
  var requestPolicyFactories = [];

  if (pipelineOptions.sendStreamingJson) {
    requestPolicyFactories.push(ndJsonPolicy());
  }

  var userAgentValue = undefined;

  if (pipelineOptions.userAgentOptions && pipelineOptions.userAgentOptions.userAgentPrefix) {
    var userAgentInfo = [];
    userAgentInfo.push(pipelineOptions.userAgentOptions.userAgentPrefix); // Add the default user agent value if it isn't already specified
    // by the userAgentPrefix option.

    var defaultUserAgentInfo = getDefaultUserAgentValue();

    if (userAgentInfo.indexOf(defaultUserAgentInfo) === -1) {
      userAgentInfo.push(defaultUserAgentInfo);
    }

    userAgentValue = userAgentInfo.join(" ");
  }

  var keepAliveOptions = Object.assign(Object.assign({}, DefaultKeepAliveOptions), pipelineOptions.keepAliveOptions);
  var retryOptions = Object.assign(Object.assign({}, DefaultRetryOptions), pipelineOptions.retryOptions);
  var redirectOptions = Object.assign(Object.assign({}, DefaultRedirectOptions), pipelineOptions.redirectOptions);

  if (isNode) {
    requestPolicyFactories.push(proxyPolicy(pipelineOptions.proxyOptions));
  }

  var deserializationOptions = Object.assign(Object.assign({}, DefaultDeserializationOptions), pipelineOptions.deserializationOptions);
  var loggingOptions = Object.assign({}, pipelineOptions.loggingOptions);
  requestPolicyFactories.push(tracingPolicy({
    userAgent: userAgentValue
  }), keepAlivePolicy(keepAliveOptions), userAgentPolicy({
    value: userAgentValue
  }), generateClientRequestIdPolicy(), deserializationPolicy(deserializationOptions.expectedContentTypes), throttlingRetryPolicy(), systemErrorRetryPolicy(), exponentialRetryPolicy(retryOptions.maxRetries, retryOptions.retryDelayInMs, retryOptions.maxRetryDelayInMs));

  if (redirectOptions.handleRedirects) {
    requestPolicyFactories.push(redirectPolicy(redirectOptions.maxRetries));
  }

  if (authPolicyFactory) {
    requestPolicyFactories.push(authPolicyFactory);
  }

  requestPolicyFactories.push(logPolicy(loggingOptions));

  if (isNode && pipelineOptions.decompressResponse === false) {
    requestPolicyFactories.push(disableResponseDecompressionPolicy());
  }

  return {
    httpClient: pipelineOptions.httpClient,
    requestPolicyFactories: requestPolicyFactories
  };
}
/**
 * Get the property parent for the property at the provided path when starting with the provided
 * parent object.
 */

export function getPropertyParent(parent, propertyPath) {
  if (parent && propertyPath) {
    var propertyPathLength = propertyPath.length;

    for (var i = 0; i < propertyPathLength - 1; ++i) {
      var propertyName = propertyPath[i];

      if (!parent[propertyName]) {
        parent[propertyName] = {};
      }

      parent = parent[propertyName];
    }
  }

  return parent;
}

function getOperationArgumentValueFromParameter(serviceClient, operationArguments, parameter, serializer) {
  return getOperationArgumentValueFromParameterPath(serviceClient, operationArguments, parameter.parameterPath, parameter.mapper, serializer);
}

export function getOperationArgumentValueFromParameterPath(serviceClient, operationArguments, parameterPath, parameterMapper, serializer) {
  var _a;

  var value;

  if (typeof parameterPath === "string") {
    parameterPath = [parameterPath];
  }

  var serializerOptions = (_a = operationArguments.options) === null || _a === void 0 ? void 0 : _a.serializerOptions;

  if (Array.isArray(parameterPath)) {
    if (parameterPath.length > 0) {
      if (parameterMapper.isConstant) {
        value = parameterMapper.defaultValue;
      } else {
        var propertySearchResult = getPropertyFromParameterPath(operationArguments, parameterPath);

        if (!propertySearchResult.propertyFound) {
          propertySearchResult = getPropertyFromParameterPath(serviceClient, parameterPath);
        }

        var useDefaultValue = false;

        if (!propertySearchResult.propertyFound) {
          useDefaultValue = parameterMapper.required || parameterPath[0] === "options" && parameterPath.length === 2;
        }

        value = useDefaultValue ? parameterMapper.defaultValue : propertySearchResult.propertyValue;
      } // Serialize just for validation purposes.


      var parameterPathString = getPathStringFromParameterPath(parameterPath, parameterMapper);
      serializer.serialize(parameterMapper, value, parameterPathString, serializerOptions);
    }
  } else {
    if (parameterMapper.required) {
      value = {};
    }

    for (var propertyName in parameterPath) {
      var propertyMapper = parameterMapper.type.modelProperties[propertyName];
      var propertyPath = parameterPath[propertyName];
      var propertyValue = getOperationArgumentValueFromParameterPath(serviceClient, operationArguments, propertyPath, propertyMapper, serializer); // Serialize just for validation purposes.

      var propertyPathString = getPathStringFromParameterPath(propertyPath, propertyMapper);
      serializer.serialize(propertyMapper, propertyValue, propertyPathString, serializerOptions);

      if (propertyValue !== undefined && propertyValue !== null) {
        if (!value) {
          value = {};
        }

        value[propertyName] = propertyValue;
      }
    }
  }

  return value;
}

function getPropertyFromParameterPath(parent, parameterPath) {
  var result = {
    propertyFound: false
  };
  var i = 0;

  for (; i < parameterPath.length; ++i) {
    var parameterPathPart = parameterPath[i]; // Make sure to check inherited properties too, so don't use hasOwnProperty().

    if (parent !== undefined && parent !== null && parameterPathPart in parent) {
      parent = parent[parameterPathPart];
    } else {
      break;
    }
  }

  if (i === parameterPath.length) {
    result.propertyValue = parent;
    result.propertyFound = true;
  }

  return result;
}
/**
 * Parses an {@link HttpOperationResponse} into a normalized HTTP response object ({@link RestResponse}).
 * @param _response - Wrapper object for http response.
 * @param responseSpec - Mappers for how to parse the response properties.
 * @returns - A normalized response object.
 */


export function flattenResponse(_response, responseSpec) {
  var parsedHeaders = _response.parsedHeaders;
  var bodyMapper = responseSpec && responseSpec.bodyMapper;

  var addOperationResponse = function addOperationResponse(obj) {
    return Object.defineProperty(obj, "_response", {
      value: _response
    });
  };

  if (bodyMapper) {
    var typeName = bodyMapper.type.name;

    if (typeName === "Stream") {
      return addOperationResponse(Object.assign(Object.assign({}, parsedHeaders), {
        blobBody: _response.blobBody,
        readableStreamBody: _response.readableStreamBody
      }));
    }

    var modelProperties = typeName === "Composite" && bodyMapper.type.modelProperties || {};
    var isPageableResponse = Object.keys(modelProperties).some(function (k) {
      return modelProperties[k].serializedName === "";
    });

    if (typeName === "Sequence" || isPageableResponse) {
      var arrayResponse = _toConsumableArray(_response.parsedBody || []);

      for (var _i2 = 0, _Object$keys2 = Object.keys(modelProperties); _i2 < _Object$keys2.length; _i2++) {
        var key = _Object$keys2[_i2];

        if (modelProperties[key].serializedName) {
          arrayResponse[key] = _response.parsedBody[key];
        }
      }

      if (parsedHeaders) {
        for (var _i3 = 0, _Object$keys3 = Object.keys(parsedHeaders); _i3 < _Object$keys3.length; _i3++) {
          var _key = _Object$keys3[_i3];
          arrayResponse[_key] = parsedHeaders[_key];
        }
      }

      addOperationResponse(arrayResponse);
      return arrayResponse;
    }

    if (typeName === "Composite" || typeName === "Dictionary") {
      return addOperationResponse(Object.assign(Object.assign({}, parsedHeaders), _response.parsedBody));
    }
  }

  if (bodyMapper || _response.request.method === "HEAD" || utils.isPrimitiveType(_response.parsedBody)) {
    // primitive body types and HEAD booleans
    return addOperationResponse(Object.assign(Object.assign({}, parsedHeaders), {
      body: _response.parsedBody
    }));
  }

  return addOperationResponse(Object.assign(Object.assign({}, parsedHeaders), _response.parsedBody));
}

function getCredentialScopes(options, baseUri) {
  if (options === null || options === void 0 ? void 0 : options.credentialScopes) {
    var scopes = options.credentialScopes;
    return Array.isArray(scopes) ? scopes.map(function (scope) {
      return new URL(scope).toString();
    }) : new URL(scopes).toString();
  }

  if (baseUri) {
    return "".concat(baseUri, "/.default");
  }

  return undefined;
}